import "./App.css";
import Aboutme from "./components/Aboutme/Aboutme";
import HomePage from "./components/HomePage/HomePage";
import Navbar from "./components/Navbar/Navbar";
import Work from "./components/Work/Work";
import Skill from "./components/Skill/Skill";
import Things from "./components/Things/Things";
import Project from "./components/Project/Project";
import Achievment from "./components/Achievment/Achievment";
import GetInTouch from "./components/GetinTouch/GetInTouch";
import Education from "./components/Education/Education";
import Codingprofile from "./components/CodingProfile/Codingprofile";

import { BrowserRouter, Routes, Route } from "react-router-dom";
import DsaPage from "./DSAPage/DsaPage";
import ScreenLoader from "./components/globalComponent/ScreenLoader/ScreenLoader";
import { useState } from "react";
import PopupProfiles from "./components/globalComponent/PopupProfiles/PopupProfiles";

function App() {
  const [flag, setflag] = useState(true);

  setTimeout(() => {
    setflag(false);
  }, 3000);

  return (
    <>
      {flag && <ScreenLoader></ScreenLoader>}
      {!flag && (
        <BrowserRouter>
          <PopupProfiles></PopupProfiles>
          <div className="App">
            <Navbar></Navbar>

            <Routes>
              <Route
                path="/"
                element={
                  <>
                    <HomePage></HomePage>
                    <div className="sections">
                      <Things></Things>
                      <Aboutme></Aboutme>
                      <Education></Education>
                      <Skill></Skill>
                      <Project></Project>
                      <Work></Work>
                      <Achievment></Achievment>
                      <Codingprofile></Codingprofile>
                      <GetInTouch></GetInTouch>
                    </div>
                  </>
                }
              />
              <Route
                path="/dsa-profile"
                element={
                  <div className="sections">
                    {" "}
                    <DsaPage />
                  </div>
                }
              />
            </Routes>
          </div>
        </BrowserRouter>
      )}
    </>
  );
}

export default App;
